<nb-card>
  <nb-card-header>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="Nhập để tìm kiếm"
          [(ngModel)]="strSearch"
          (change)="onSearch()"
        />
        <button
          nbSuffix
          nbButton
          ghost
          shape="semi-round"
          nbTooltip="Tra cứu"
          (click)="search()"
        >
          <nb-icon icon="search-outline"> </nb-icon>
        </button>
      </nb-form-field>

      <!-- <nb-checkbox
        *ngIf="mode === 'review'"
        [(ngModel)]="isApproved"
        status="warning"
        (change)="onSearch()"
        >Duyệt</nb-checkbox
      > -->

      <nb-select
        *ngIf="mode === 'review'"
        outline
        shape="round"
        size="small"
        status="info"
        (selectedChange)="selectedCategory($event)"
        [(ngModel)]="category"
      >
        <nb-option value="all"> Tất cả </nb-option>
        <nb-option value="approved"> Đã duyệt </nb-option>
        <nb-option value="unapproved"> Chưa duyệt </nb-option>
      </nb-select>

      <button
        *ngIf="(userService.$isAuthenticated | async) && mode !== 'review'"
        type="submit"
        nbButton
        outline
        shape="semi-round"
        status="primary"
        size="small"
        (click)="onNew()"
        [disabled]="loading"
        [class.btn-pulse]="loading"
      >
        Tạo mới
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="row">
      <div
        *ngFor="let item of display; let i = index"
        [class.col-md-6]="mode === 'review'"
        [class.col-md-12]="mode !== 'review'"
      >
        <ngx-view-lecture
          [lecture]="item"
          [mode]="mode"
          (onDelete)="onDelete($event)"
          (onEdit)="onEdit($event)"
        ></ngx-view-lecture>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer *ngIf="!done">
    <nb-actions fullWidth size="small" class="see-more-button">
      <nb-action (click)="getMore()">
        <nb-icon icon="more-horizontal-outline"></nb-icon>
        <span class="text-link">Xem thêm</span>
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
